import React from "react";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";
import {
  DoorGlassMaterial,
  getFramePositions,
  getFrameScaling,
} from "../../../../../shared/utils/door";
import { defaultDoorHeight } from "shared/utils/doorSceneConstants";

interface FrameProps {
  doorNodes: any;
  materials: DoorGlassMaterial;
  index: number;
}

const Frame: React.FC<FrameProps> = ({
  doorNodes,
  materials,
  index,
}: FrameProps) => {
  const {
    getConfigurationHeight,
    getConfigurationWidth,
    getConfigurationColor,
    selfAssembleDoorData,
  } = useConfigurationOptionsContext();

  const height = getConfigurationHeight(index);
  const width = getConfigurationWidth(index);

  const positions = getFramePositions(width, height);
  const positionsReversed = getFramePositions(width, height, true);
  const scaling = getFrameScaling(width, height);

  const showMiddleHinge =
    !selfAssembleDoorData.selfAssembly ||
    (selfAssembleDoorData.measurements.hingeAmount || 3) === 3;

  return (
    <group dispose={null}>
      <mesh
        geometry={doorNodes["frame_bottom"].geometry}
        material={materials[getConfigurationColor()]}
        scale={scaling.horizontal}
        position={positions.bottom}
      ></mesh>
      <mesh
        geometry={doorNodes["frame_left"].geometry}
        material={materials[getConfigurationColor()]}
        scale={scaling.vertical}
        position={positions.left}
      ></mesh>
      <mesh
        geometry={doorNodes["frame_right"].geometry}
        material={materials[getConfigurationColor()]}
        scale={scaling.vertical}
        position={positions.right}
      ></mesh>
      <mesh
        geometry={doorNodes["frame_top"].geometry}
        material={materials[getConfigurationColor()]}
        scale={scaling.horizontal}
        position={[positions.top.x, positions.top.y, 0]}
      ></mesh>
      <mesh
        geometry={doorNodes["misc_0"].geometry}
        material={materials[getConfigurationColor()]}
        position={[positionsReversed.right.x, positions.top.y, 0]}
      ></mesh>
      <mesh
        geometry={doorNodes["misc_1"].geometry}
        material={materials[getConfigurationColor()]}
        position={[positionsReversed.right.x, positions.top.y, 0]}
        visible={showMiddleHinge}
      ></mesh>
      <mesh
        geometry={doorNodes["misc_2"].geometry}
        material={materials[getConfigurationColor()]}
        position={[positionsReversed.right.x, positions.bottom.y, 0]}
      ></mesh>
    </group>
  );
};

export default Frame;
